var exports = {
  "an": "ErrorFallback.module__errorFallbackContainer___OGppX1",
  "MU": "ErrorFallback.module__errorFallbackIcon___OGppX1",
  "S6": "ErrorFallback.module__errorFallbackContent___OGppX1",
  "jQ": "ErrorFallback.module__errorFallbackTitle___OGppX1",
  "pF": "ErrorFallback.module__errorFallbackDescription___OGppX1",
  "sM": "ErrorFallback.module__errorFallbackActions___OGppX1",
};

module.exports = exports;
